import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { Site } from "../../types/site";

export interface SiteFilters {
  bu?: number;
  societe?: number;
  activite?: number;
  filiere?: number;
  region?: number;
}

export const useGetSites = (filters?: SiteFilters) => {
  const queryParams = new URLSearchParams();
  if (filters?.bu) queryParams.append("bu", filters.bu.toString());
  if (filters?.societe) queryParams.append("societe", filters.societe.toString());
  if (filters?.activite) queryParams.append("activite", filters.activite.toString());
  if (filters?.filiere) queryParams.append("filiere", filters.filiere.toString());
  if (filters?.region) queryParams.append("region", filters.region.toString());

  const queryString = queryParams.toString();
  const endpoint = queryString ? `/iam/sites/?${queryString}` : "/iam/sites/";

  return useQuery({
    queryKey: ["sites", filters],
    queryFn: async (): Promise<Site[]> => {
      const resp = await fetchClient<Site[]>(endpoint);
      if (resp.error || !resp.data) throw resp.error || new Error("Failed to fetch sites");
      return resp.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};

export default useGetSites;
